enum LocalStorageKeys {
	userToken = 'userToken',
	deviceToken = 'deviceToken',
	lastUserActionTime = 'lastUserActionTime',
	lastTokenRetrievalTime = 'lastTokenRetrievalTime'
}

export default LocalStorageKeys;
